import PropsTypes from "prop-types";

const operatorExportOrderLakeProps = {
  type: {
    isOpenModal: PropsTypes.bool.isRequired,
    setIsOpenModal: PropsTypes.func.isRequired,
  },
};

export default operatorExportOrderLakeProps;
